/*
 * Copyright Huesik (c) 2019.
 */

import axiosInstance from '../core/modules/axiosInstance'
import Url from '../utils/Url'

const kosiwons = {
  async fetch (params) {
    const lat = params.lat
    const lng = params.lng
    const range = params.range || 500
    const moneyRange = params.moneyRange || []
    const useSexType = params.useSexType || []
    const optionsFilter = params.optionsFilter || {}
    const roomType = params.roomType || []

    console.log(optionsFilter)

    return await axiosInstance.get(`/kosiwons/listByRange?lat=${lat}&lng=${lng}&range=${range}&money_range=${moneyRange}&room_type=${roomType}&use_sex_type=${useSexType}&${Url.objectToQueryString(optionsFilter)}`)
  },

  async detail (param) {
    const id = param.id

    return await axiosInstance.get(`/kosiwons/${id}`)
  },

  async boundsFetch (params) {
    const sw = params.sw
    const ne = params.ne
    const moneyRange = params.moneyRange || []
    const useSexType = params.useSexType || []
    const optionsFilter = params.optionsFilter || {}
    const roomType = params.roomType || []
    // ?sw=${sw}&ne=${ne}&range=${range}&money_range=${moneyRange}&room_type=${roomType}&use_sex_type=${useSexType}&${Url.objectToQueryString(optionsFilter)}`
    return await axiosInstance.post('/kosiwons/listByBounds', {
      sw,
      ne,
      money_range: moneyRange,
      use_sex_type: useSexType,
      room_type: roomType,
      ...optionsFilter
    })
  }
}

export default kosiwons

